import React from "react";
import {postData} from "../../../../utils/request";

export default class Targets extends React.Component {

    state = {
        sendTo: null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values?.id !== prevProps.values?.id || JSON.stringify(this.props.values?.filter) !== JSON.stringify(prevProps.values?.filter)) {
            this.loadList();
        }
    }

    componentDidMount() {
        this.loadList();
    }

    loadList = () => {
        this.targets = postData({
            action: "NewsletterTarget.getRecipients",
            id: this.props.values?.id,
            count: true,
        }, {}, {showError: false});
        this.targets.then((response) => {
            this.setState({
                sendTo: parseInt(response.fullcount)
            });
        });
    }

    render() {
        return this.state.sendTo === null ? "..." : this.state.sendTo;
    }
}